module.exports = __webpack_public_path__ + "img/sticker-subtitle.6a0c20b4.png";